export default __webpack_public_path__ + "static/media/cat.85c72f54.svg";